export default class Menu{
  constructor(elem) {
    this.menus = document.querySelectorAll(elem);
    for (var i = 0; i < this.menus.length; i++) {
      this.submenu  = this.menus[i].querySelectorAll('.menu-item-has-children > a');
      for (var j = 0; j < this.submenu.length; j++) {
        var submenu = this.submenu[j];
        var icon = document.createElement("i");
        icon.className = "icon icon-cheveron-down";
        submenu.appendChild(icon);
        
        submenu.onclick = function(e){
          e.preventDefault();
          e.stopPropagation();
          const parent = this.parentElement;
          const menu = parent.parentElement;
          const children = [].slice.call(menu.children);
          children.forEach(child => {
            if(child != parent)
              child.classList.remove("open-submenu")
          })
          parent.classList.toggle("open-submenu");
        }
      }
    }

    const body = document.body;
    body.onclick = function(){
      var open_submenus = document.querySelectorAll('.open-submenu');
      for (var i = 0; i < open_submenus.length; i++) {
        open_submenus[i].classList.toggle("open-submenu");
      }
    }
  }
}


// WEBPACK FOOTER //
// ./scripts/util/Menu.js